<template>
  <div class="column-inner">
    <terms-of-service-panel />
    <staff-panel />
    <LocalBubblePanel v-if="showLocalBubblePanel" />
    <MRFTransparencyPanel />
    <features-panel v-if="currentUser && showFeaturesPanel" />
  </div>
</template>

<script src="./about.js"></script>

<style lang="scss">
</style>
